import fastDeepEqual from 'fast-deep-equal/es6'

/**
 * Checks that a value is not nil.
 * @param value
 */
export function isNotNil<T>(
  value: T | null | undefined,
): value is Exclude<T, null | undefined> {
  return value !== undefined && value !== null
}

/**
 * Whether the values are deeply equal.
 *
 * @param left
 * @param right
 */
export function deepEqual<T>(left: T, right: T): boolean {
  return fastDeepEqual(left, right)
}
